import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import { useState } from "react";

export const IPInput = ({ setIP, isConnected }) => {
	const [disabledState, setDisabledState] = useState(false)
	const [input, setInput] = useState(
		localStorage.getItem("TrackmanIP") || "192.168.0.100"
	);
	return (
		<Grid>
			<Grid item xs={12} display="flex" justifyContent="center">
				<Typography variant="overline" sx={{ color: "white" }}>
					Please enter the IP address of the Trackman you would like to listen
					to.
				</Typography>
			</Grid>
			<Grid item xs={12} gap={'1%'} display="flex" justifyContent="center">
				<TextField
					value={input}
					onChange={(evt) => setInput(evt.target.value)}
					variant="outlined"
					sx={{ backgroundColor: "white", borderRadius: "4px" }}
				/>
				{!isConnected && (
					<Button
					variant="contained"
					onClick={() => {
						setIP(input)
						setDisabledState(true)
						setTimeout(() => {
							setDisabledState(false)
						}, [10000])
					}}
					disabled={(input.length > 0 ? false : true) || disabledState}
					style={{ backgroundColor: "#00AEEF", color: "white" }}
				>
					Enter
				</Button>
				)}
			</Grid>
		</Grid>
	);
};
